<template>
  <div id="academic_interdisciplinary">
    <usc-hero :title="this.hero.title" :loResSrc="this.hero.loResSrc" :hiResSrc="this.hero.hiResSrc"
      :color="this.page.color"></usc-hero>
    <usc-intro>
      <p>The brand-new joint bachelor of science in Real Estate Finance and Development (REFD) combines Marshall’s
        expertise in financial valuation and capital markets with the USC Price School of Public Policy’s strengths in
        development and urban land use. </p>
    </usc-intro>
    <div class="body gutter-lg mb">
      <p><i>You will master skills and knowledge through numerous experiential-learning courses that emphasize
          real-world opportunities in securities trading, real estate development and valuation. You’ll also benefit
          from both schools’ longstanding ties with local, national and international real estate development and
          investment firms and opportunities for summer internships.</i></p>
      <p>All students will gain access to career services in both schools and be eligible for Marshall’s signature
        international experiences, including our Learning about International Commerce (open to all first-year students)
        and Global Leadership Program (invitation only). With intimate class sizes, you’ll engage in integrated
        training, gain real-world experience and connect with industry leaders.</p>
    </div>
    <div class="body gutter-lg mb">
      <h2><strong>Core Courses</strong></h2>
      <h3>Marshall courses (48 units) will build skills in:</h3>
      <ul>
        <li>Accounting</li>
        <li>Economics</li>
        <li>Marketing</li>
        <li>Analytics</li>
        <li>Leadership and organizational behavior</li>
        <li>Strategy</li>
        <li>Operations management</li>
        <li>Communications</li>
        <li>Real estate finance and investment</li>
      </ul>

      <h3>Price courses (42 units) will develop firm foundations in:</h3>

      <ul>
        <li>Development</li>
        <li>Urban planning</li>
        <li>Community design</li>
        <li>Real estate law and policy</li>
        <li>Real estate market analysis</li>
      </ul>
      <h2>The program requires completion of at least one of the following experiential learning courses:</h2>
      <ul>
        <li>Real estate investment trust (REIT), including hands-on management of an actual REIT</li>
        <li>Mixed-use development, in which you will apply and grow your knowledge in design, finance, real estate policy and management through a field project</li>
      </ul>
    </div>
    <usc-course-chart :dataSet="courseData">
      <img slot="image" src="../../../static/USC_Marshall_CurriculumMap_2023_REFD_R2.png" alt="Course chart for Real Estate Finance and Development Program">
    </usc-course-chart>
  </div>
</template>

<script>
import hero from '@/components/Hero'
import intro from '@/components/Intro'
import table from '@/components/Table'
import Cta from '@/components/Cta'
import CourseChart from '@/components/CourseChart/CourseChart'

export default {
  name: 'UndergradAccounting',
  components: {
    'usc-hero': hero,
    'usc-intro': intro,
    'usc-table': table,
    'usc-cta': Cta,
    'usc-course-chart': CourseChart
  },
  data () {
    return {
      page: {
        color: '#ffcc00'
      },
      hero: {
        title: 'Real Estate Finance + Development (REFD)',
        loResSrc: '../../../static/HeroImages/Marshall137-High.jpg',
        hiResSrc: '../../../static/HeroImages/Marshall137-High.jpg'
      },
      table: {
        title: 'Core Courses',
        data: [
          {
            left: 'Writing and Critical Reasoning',
            right: 'WRIT 150'
          },
          {
            left: 'Advanced Writing',
            right: 'WRIT 340'
          },
          {
            left: 'Introduction to Programming',
            right: 'CSCI 103L'
          },
          {
            left: 'Data Structures and Object-Oriented Design',
            right: 'CSCI 104L'
          },
          {
            left: 'Introduction to Computing',
            right: 'CSCI 109'
          },
          {
            left: 'Discrete Methods in Computer Science',
            right: 'CSCI 170'
          },
          {
            left: 'Principles of Software Development',
            right: 'CSCI 201L'
          },
          {
            left: 'Introduction to Algorithms and Theory of Computing',
            right: 'CSCI 270'
          },
          {
            left: 'Design and Construction of Large Software Systems',
            right: 'CSCI 477ab'
          },
          {
            left: 'Introduction to Digital Logic',
            right: 'EE 101'
          },
          {
            left: 'Introduction to Digital Circuits',
            right: 'EE 201L'
          },
          {
            left: 'Freshmen Academy Seminar',
            right: 'ENGR 102'
          },
          {
            left: 'Calculus I',
            right: 'MATH 125'
          },
          {
            left: 'Calculus II',
            right: 'MATH 126'
          },
          {
            left: 'Linear Algebra and Linear Differential Equations',
            right: 'MATH 225'
          },
          {
            left: 'Applied Linear Algebra for Engineering',
            right: 'EE 241'
          },
          {
            left: 'Fundamentals of Physics II: Electricity and Magnetism',
            right: 'PHYS 151L'
          },
          {
            left: 'Accounting for Non-Business Majors',
            right: 'ACCT 410x'
          },
          {
            left: 'Communication Strategy in Business',
            right: 'BUAD 302'
          },
          {
            left: 'Organizational Behavior',
            right: 'BUAD 304'
          },
          {
            left: 'Business Finance',
            right: 'BUAD 306'
          },
          {
            left: 'Marketing Fundamentals',
            right: 'BUAD 307'
          },
          {
            left: 'Applied Business Statistics or BUAD 364',
            right: 'BUAD 310'
          },
          {
            left: 'Operations Management',
            right: 'BUAD 311'
          },
          {
            left: 'Strategic Management',
            right: 'BUAD 497'
          },
          {
            left: 'Microeconomics for Business',
            right: 'ECON 351x'
          },
          {
            left: 'Macroeconomics for Business',
            right: 'ECON 352x'
          },
          {
            left: 'Introduction to Probability and Statistics for Electrical Engineering',
            right: 'EE 364'
          }
        ],
        disclaimer: ''
      },
      courseData: {
        title: 'Real Estate Finance and Development Program',
        subtitle: 'FOUR-YEAR SAMPLE COURSE SEQUENCE',
        key: [
          {
            courseColor: 'marshall-core',
            courseLabel: 'Marshall Core'
          },
          {
            courseColor: 'usc-requirement',
            courseLabel: 'USC Requirement'
          },
          {
            courseColor: 'realestate',
            courseLabel: 'Real Estate Finance & Dev'
          }
        ],
        years: {
          freshman: {
            yearTitle: 'FRESHMAN',
            semesters: {
              Fall: [
                {
                  courseID: 'MATH 118',
                  courseName: 'Fundatmental Principles of Calculus',
                  courseColor: 'marshall-core',
                  hasMin: false,
                  min: 4,
                  courseCredits: 4
                },
                {
                  courseID: 'BUAD 304',
                  courseName: 'Organizational Behavior and Leadership',
                  courseColor: 'marshall-core',
                  hasMin: false,
                  min: 4,
                  courseCredits: 4
                },
                {
                  courseID: 'RED 200',
                  courseName: 'Introduction to Real Estate',
                  courseColor: 'realestate',
                  hasMin: false,
                  min: 4,
                  courseCredits: 4
                },
                {
                  courseID: 'WRIT 150',
                  courseName: 'Writing and Critical Reasoning',
                  courseColor: 'usc-requirement',
                  hasMin: false,
                  min: 4,
                  courseCredits: 4
                }
              ],
              Spring: [
                {
                  courseID: 'ECON 351x',
                  courseName: 'Microeconomics for Business',
                  courseColor: 'marshall-core',
                  hasMin: false,
                  min: 4,
                  courseCredits: 4
                },
                {
                  courseID: 'BUAD 310 or 312',
                  courseName: 'Applied Business Stats or Stats & Data Science for BUsiness',
                  courseColor: 'marshall-core',
                  hasMin: false,
                  min: '4',
                  courseCredits: '4'
                },
                {
                  courseID: 'PPD 245',
                  courseName: 'The Urban Context',
                  courseColor: 'realestate',
                  hasMin: false,
                  min: 3,
                  courseCredits: 3
                },
                {
                  courseID: 'GESM',
                  courseName: 'General Education Seminar',
                  courseColor: 'usc-requirement',
                  hasMin: false,
                  min: 4,
                  courseCredits: 4
                },
                {
                  courseID: 'Optional Elective',
                  courseName: 'BUAD 104',
                  courseColor: 'marshall-core',
                  hasMin: false,
                  min: 2,
                  courseCredits: 2
                }
              ]
            }
          },
          sophmore: {
            yearTitle: 'SOPHOMORE',
            semesters: {
              Fall: [
                {
                  courseID: 'BUAD 280',
                  courseName: 'Introduction to Financial Accounting',
                  courseColor: 'marshall-core',
                  hasMin: false,
                  min: 3,
                  courseCredits: 3
                },
                {
                  courseID: 'BUAD 302',
                  courseName: 'Communication Strategy in Business',
                  courseColor: 'marshall-core',
                  hasMin: false,
                  min: 4,
                  courseCredits: 4
                },
                {
                  courseID: 'Buad 306 or 308',
                  courseName: 'Business Finace or Advanced Business Finance',
                  courseColor: 'marshall-core',
                  hasMin: false,
                  min: 4,
                  courseCredits: 4
                },
                {
                  courseID: 'RED 362',
                  courseName: 'Real Estate Development Fundamentals',
                  courseColor: 'realestate',
                  hasMin: false,
                  min: 4,
                  courseCredits: 4
                },
                {
                  courseID: 'RED 201',
                  courseName: 'Real Estate Career Seminar',
                  courseColor: 'realestate',
                  hasMin: false,
                  min: 2,
                  courseCredits: 2
                }
              ],
              Spring: [
                {
                  courseID: 'BUAD 281',
                  courseName: 'Introduction to Managerial Accounting',
                  courseColor: 'marshall-core',
                  hasMin: false,
                  min: 3,
                  courseCredits: 3
                },
                {
                  courseID: 'ECON 352x',
                  courseName: 'Macroeconomics for Business',
                  courseColor: 'marshall-core',
                  hasMin: false,
                  min: 4,
                  courseCredits: 4
                },
                {
                  courseID: 'BUAD 307',
                  courseName: 'Marketing Fundamentals',
                  courseColor: 'marshall-core',
                  hasMin: false,
                  min: 4,
                  courseCredits: 4
                },
                {
                  courseID: 'FBE 391',
                  courseName: 'Real Estate Finance and Investement',
                  courseColor: 'realestate',
                  hasMin: false,
                  min: 4,
                  courseCredits: 4
                },
                {
                  courseID: 'FBE 495',
                  courseName: 'Practicum in Business Issue',
                  courseColor: 'realestate',
                  hasMin: false,
                  min: 1,
                  courseCredits: 1
                }
              ]
            }
          },
          junior: {
            yearTitle: 'JUNIOR',
            semesters: {
              Fall: [
                {
                  courseID: 'BUAD 311 or 313',
                  courseName: 'Operations Management or Advanced Operations Management & Analytics',
                  courseColor: 'marshall-core',
                  hasMin: false,
                  min: 4,
                  courseCredits: 4
                },
                {
                  courseID: 'BUAD 497',
                  courseName: 'Strategic Management',
                  courseColor: 'marshall-core',
                  hasMin: false,
                  min: 4,
                  courseCredits: 4
                },
                {
                  courseID: 'RED 435',
                  courseName: 'Analyzing Real Estate Markets',
                  courseColor: 'realestate',
                  hasMin: false,
                  min: 4,
                  courseCredits: 4
                },
                {
                  courseID: 'RED 417',
                  courseName: 'History of Planning & Development',
                  courseColor: 'realestate',
                  hasMin: false,
                  min: 4,
                  courseCredits: 4
                }
              ],
              Spring: [
                {
                  courseID: 'BUAD 425',
                  courseName: 'Introduction to Business Analytics',
                  courseColor: 'marshall-core',
                  hasMin: false,
                  min: 2,
                  courseCredits: 2
                },
                {
                  courseID: 'RED 437',
                  courseName: 'Advanced Finance and Investment for Real Estate Development',
                  courseColor: 'realestate',
                  hasMin: false,
                  min: 4,
                  courseCredits: 4
                },
                {
                  courseID: 'FBE 466 or 489',
                  courseName: 'Management of Real Estate Dev or Real Estate Capital Market',
                  courseColor: 'realestate',
                  hasMin: false,
                  min: 4,
                  courseCredits: 4
                },
                {
                  courseID: 'GE',
                  courseName: '',
                  courseColor: 'usc-requirement',
                  hasMin: false,
                  min: '4',
                  courseCredits: '4'
                },
                {
                  courseID: 'RED 301',
                  courseName: 'Real Estate Internship Seminar',
                  courseColor: 'realestate',
                  hasMin: false,
                  min: 1,
                  courseCredits: 1
                }
              ]
            }
          },
          senior: {
            yearTitle: 'SENIOR',
            semesters: {
              Fall: [
                {
                  courseID: 'FBE 427',
                  courseName: 'Real Estate law',
                  courseColor: 'realestate',
                  hasMin: false,
                  min: 4,
                  courseCredits: 4
                },
                {
                  courseID: 'RED 425',
                  courseName: 'Designing Livable Communities',
                  courseColor: 'realestate',
                  hasMin: false,
                  min: 4,
                  courseCredits: 4
                },
                {
                  courseID: 'GE',
                  courseName: '',
                  courseColor: 'usc-requirement',
                  hasMin: false,
                  min: 4,
                  courseCredits: 4
                },
                {
                  courseID: 'WRIT 340',
                  courseName: 'Advanced Writing',
                  courseColor: 'usc-requirement',
                  hasMin: true,
                  min: 3,
                  courseCredits: 4
                }
              ],
              Spring: [
                {
                  courseID: 'FBE 467 or RED 469',
                  courseName: 'Real Estate Investment Trust (REIT) or Mixed Use Dev Process',
                  courseColor: 'realestate',
                  hasMin: false,
                  min: '4',
                  courseCredits: '4'
                },
                {
                  courseID: 'GE',
                  courseName: '',
                  courseColor: 'usc-requirement',
                  hasMin: false,
                  min: 4,
                  courseCredits: 4
                },
                {
                  courseID: 'GE',
                  courseName: '',
                  courseColor: 'usc-requirement',
                  hasMin: false,
                  min: 4,
                  courseCredits: 4
                },
                {
                  courseID: 'GE',
                  courseName: '',
                  courseColor: 'usc-requirement',
                  hasMin: false,
                  min: 4,
                  courseCredits: 4
                }
              ]
            }
          }
        }
      }
    }
  },
  created () {
    this.$root.setPageHeader('Academics', 'Combined Computer Science/Business Administration')
  }
}
</script>

<style scoped lang="scss">
ul li {
  list-style-type: disc;
  margin-left: 20px;
  padding-left: 20px;
}
</style>


// WEBPACK FOOTER //
// src/pages/academics/RealEstate.vue